import ContactModal from '~/components/ContactModal';

export default function CTA() {
  return (
    <section className="text-center py-16 bg-gray-800 from-purple-800 to-blue-800 text-white px-6">
      <h2 className="text-3xl sm:text-4xl font-extrabold">
        Let's Collaborate <span className="text-orange-400">Together</span>
      </h2>
      <p className="mt-4 text-sm sm:text-lg max-w-3xl mx-auto">
        I specialize in building <span className="text-red-400 font-extrabold">ambitious</span> and <span className="text-blue-400 font-extrabold">user-friendly</span> products. Whether you're looking to turn a groundbreaking idea into reality or enhance your existing product, I'm here to help you succeed.
      </p>
      {/* Use ContactModal instead of Link */}
      <div className="mt-8">
        <ContactModal />
      </div>
    </section>
  );
}
